import { HStack, Text } from "@chakra-ui/react"
import { Link, useRouterState } from "@tanstack/react-router"

interface ReportBreadcrumbProps {
  reportJobId?: string
  reportJobName?: string
  reportName?: string
}

export function ReportBreadcrumb({ reportJobId, reportJobName, reportName }: ReportBreadcrumbProps) {
  const router = useRouterState()
  const currentPath = router.location.pathname

  const isOnReportJobPage = currentPath.startsWith(`/reportJob/${reportJobId}`)

  return (
    <HStack gap={1} fontSize="sm" mb={4}>
      <Link to="/reports">
        <Text color="blue.500" _hover={{ textDecoration: "underline" }}>
          리포트 생성
        </Text>
      </Link>

      {reportJobId && reportJobName && (
        <>
          <Text>&gt;</Text>
          {isOnReportJobPage ? (
            <Text color="gray.700">{reportJobName}</Text>
          ) : (
            <Link to="/reportJob/$reportJobId" params={{ reportJobId }}>
              <Text color="blue.500" _hover={{ textDecoration: "underline" }}>
                {reportJobName}
              </Text>
            </Link>
          )}
        </>
      )}

      {reportName && (
        <>
          <Text>&gt;</Text>
          <Text color="gray.700">{reportName}</Text>
        </>
      )}
    </HStack>
  )
}
